import { endOfDay, startOfDay } from 'date-fns';

import { Frame } from 'features/Frames/types';
import { EventConfig } from 'mocks/server/utils/events';

export const DATE = new Date();
export const START_DATE = startOfDay(DATE);
export const END_DATE = endOfDay(DATE);
export const AZURE_AD_AUTH_PATHS = 'https://login.microsoftonline.com/**';
export const DELIVERY_OVERALL = null;
export const DEMAND_OVERALL = null;
export const DELIVERY_HISTORY = [10, 20, 30, 40, 50, 60, 70, 80, 90, 100];
export const DEMAND_HISTORY = [10, 20, 30, 40, 50, 60, 70, 80, 90, 100];
export const FIELDS_TO_SEARCH: Array<keyof Frame> = [
  'id',
  'displayUnitId',
  'broadsignFrameId',
  'name',
];

// Ensure weightings equal 100% total
export const EVENT_CONFIGS: EventConfig[] = [
  { type: 'Play', weight: 30 },
  { type: 'Ad', weight: 30 },
  { type: 'Skip', weight: 25 },
  { type: 'Error', weight: 5 },
  { type: 'Filler', weight: 5 },
  { type: 'Sync', weight: 5 },
];
